import { sendRequest } from 'js-api'

export default {
  pageView: () => sendRequest('GET', 'member/api/session/page-view', {
    ignoreUnauthorized: true
  })
}
